import { BusinessContextModel } from '../../core/model/BusinessContext.model';
import { L3ServiceLocationsHttpQuery } from './L3ServiceLocationsQuery.config';

export const L3ServiceLocationBusinessContextConfig: BusinessContextModel = {
  translateNamespace: 'topology',
  queries: L3ServiceLocationsHttpQuery,
};
